// User-supplied & curated assets (logos, hero video, RAC imagery)

const UNSPLASH = "https://images.unsplash.com";
const Q = "?auto=format&fit=crop&w=1200&q=70";
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const ASSETS = {
  // Hero background video — self-hosted on backend for persistence (was an
  // external CDN URL, now lives at /api/uploads/brand/hero-bg-v3.mp4 so
  // backups + content moderation are owned). Replaced 2026-06-24 with the
  // user-supplied WhatsApp clip showing the conscious-walk meditation.
  heroVideo: `${BACKEND}/api/uploads/brand/hero-bg-v3.mp4`,
  // Random Acts of Consciousness logo — gold rings with blue drop
  racLogo:
    "https://customer-assets.emergentagent.com/job_docm-showcase/artifacts/s137nkxl_RAC%20image%20.jpeg",
  // Voice of Consciousness logo — circular navy script + gold ring (June 2026)
  vocLogo: `${BACKEND}/api/uploads/brand/voc/voice-of-consciousness-logo.png`,
  // 11·11 Consciousness Day logo — square (1600×1600) with navy "11", gold
  // "11", flower-of-life symbol, human profile with mandala and "CONSCIOUSNESS
  // DAY FOR HUMANITY" caption. Cache-busted via `?v=` when the asset is
  // replaced so browsers pick up the new artwork immediately.
  consciousnessDayLogo:
    `${process.env.REACT_APP_BACKEND_URL}/api/uploads/brand/1111-logo.png?v=20260805`,
  // Reference website composition (optional secondary)
  websiteRef:
    "https://customer-assets.emergentagent.com/job_docm-showcase/artifacts/5z9hi32h_Website%20image%201.jpeg",
};

// Curated, wide-format symbolic photography for the marquee — chosen so no
// portrait composition gets cropped at the head in the 1.5:1 tiles.
export const RAC_ASSETS = {
  marquee: [
    `${UNSPLASH}/photo-1469474968028-56623f02e42e${Q}`,
    `${UNSPLASH}/photo-1502082553048-f009c37129b9${Q}`,
    `${UNSPLASH}/photo-1542038784456-1ea8e935640e${Q}`,
    `${UNSPLASH}/photo-1473773508845-188df298d2d1${Q}`,
    `${UNSPLASH}/photo-1497290756760-23ac55edf36f${Q}`,
    `${UNSPLASH}/photo-1444703686981-a3abbc4d4fe3${Q}`,
    `${UNSPLASH}/photo-1490730141103-6cac27aaab94${Q}`,
  ],
  // "Consciousness in Action" photo — user-supplied black & white daisies
  // artwork, self-hosted on the backend so it can never break.
  feature: `${BACKEND}/api/uploads/brand/rac-feature-v2.jpg`,
  // Ripple artwork (self-hosted on the backend)
  ripples: [
    `${BACKEND}/api/uploads/brand/rac-ripple-1.png`,
    `${BACKEND}/api/uploads/brand/rac-ripple-2.png`,
    `${BACKEND}/api/uploads/brand/rac-ripple-3.png`,
  ],
};
